import Icon from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ChevronDown from "@ucs/Icons/ChevronDownLarge";
import ChevronUp from "@ucs/Icons/ChevronUp";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import styled, { css } from "styled-components";

export interface CollapsibleStyles {
    wrapper?: InjectableCss;
    header?: InjectableCss;
    content?: InjectableCss;
}

const CollapsibleWrapper = styled("div")<InjectableCss & { isShown: boolean }>`
    padding: 20px 25px;
    background-color: ${p => (p.isShown ? "white" : "transparent")};
    ${injectCss}
`;
const CollapsibleHeader = styled.div<InjectableCss>`
    cursor: pointer;
    position: relative;
    ${injectCss}
`;
const CollapsibleContent = styled("div")<InjectableCss & { isShown: boolean }>`
    display: ${p => (p.isShown ? "block" : "none")};
    /* visibility: ${p => (p.isShown ? "visible" : "hidden")}; */
    height: ${p => (p.isShown ? "100%" : "0")};
    ${injectCss}
`;

export interface OwnProps {
    title: string;
    extendedStyles?: CollapsibleStyles;
    children: any;
}

export const Collapsable: React.FC<OwnProps> = ({ title, children, extendedStyles }) => {
    const [collapsed, setCollapsed] = React.useState(true);

    return (
        <CollapsibleWrapper isShown={!collapsed} {...extendedStyles?.wrapper}>
            <CollapsibleHeader onClick={() => setCollapsed(!collapsed)} {...extendedStyles?.header}>
                <Typography as="h3" variant="h3">
                    {title}
                </Typography>
                <Icon
                    color={UCSColors.gray04}
                    css={css`
                        position: absolute;
                        top: 0px;
                        bottom: 0px;
                        right: 15px;
                        margin: auto;
                    `}
                    src={collapsed ? ChevronDown : ChevronUp}
                />
            </CollapsibleHeader>
            <CollapsibleContent isShown={!collapsed} {...extendedStyles?.content}>
                {children}
            </CollapsibleContent>
        </CollapsibleWrapper>
    );
};
